import { useLazyQuery } from '@apollo/client';
import { EuiFormLabel, EuiComboBox, EuiComboBoxOptionOption } from '@elastic/eui';
import { BRAND_NAMES } from 'apollo-client/queries/getAvailableBrandNames';
import { brandNames } from 'cache';
import { Query, QueryGetAvailableBrandNamesArgs } from 'generated/graphql';
import { useLocalCache } from 'hooks/useLocalCache';
import { useIntl } from 'react-intl';

import * as S from './FiltersSidebar.styles';

export const BrandFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();
  const [onGetAvailableBrandNames, { loading, data }] = useLazyQuery<Query, QueryGetAvailableBrandNamesArgs>(
    BRAND_NAMES,
    {
      fetchPolicy: 'network-only',
    }
  );

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>{formatMessage({ id: 'filters.brand.label' })}</EuiFormLabel>
      <EuiComboBox
        async
        isLoading={loading}
        placeholder={formatMessage({ id: 'filters.brand.placeholder' })}
        options={data?.getAvailableBrandNames?.map((x: string) => ({ label: x, value: x })) ?? []}
        selectedOptions={localFilters?.data?.brandNames?.map((x: string) => ({ label: x, value: x }))}
        onSearchChange={(e: string): void => {
          onGetAvailableBrandNames({ variables: { inputBrandName: e } });
        }}
        onClick={(): void => {
          onGetAvailableBrandNames({ variables: { inputBrandName: '' } });
        }}
        onChange={(x: EuiComboBoxOptionOption<string>[]): void => {
          brandNames(x?.map(({ value }) => value) as string[]);
        }}
      />
    </S.SidebarFilterWrapper>
  );
};
